<script>
import ModalComponent from "../../../../../components/ModalComponent.vue";
import { computed, ref } from "vue";

export default {
  name: "ModalChoiceNotifyComponent" ,
  components: {
    ModalComponent
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    createSubmitPreOrderHandler: {
      type: Function,
      required: true
    }
  },
  setup(props, context) {

    const show = computed(() => props.show);
    const value = ref(props);

    const handleChange = (e) => {
      context.emit('update:value', parseInt(e.target.value));
    };

    return {
      show,
      value,
      handleChange
    }
  }
}
</script>

<template>
  <modal-component
    :show="show"
    title="Уведомления"
    :width-percent="35"
    :min-width-px="400"
  >
    <template v-slot:body>
      <div class="send-to-choice">
        <h2>На вашем номере телефона есть WhatsApp. Как вам будет удобнее в дальнейшем получать уведомления по заказу?</h2>
        <div>
          <div class="form-group">
            <input type="radio" name="send-to" value="1" v-model="value" @change="handleChange" />
            <label>по СМС</label>
          </div>
          <div class="form-group">
            <input type="radio" name="send-to" value="2" v-model="value" @change="handleChange" />
            <label>уведомлять на WhatsApp</label>
          </div>
        </div>
        <div class="align-right">
          <button type="button" @click="createSubmitPreOrderHandler" class="btn btn-primary">Отправить на проверку</button>
        </div>
      </div>
    </template>
  </modal-component>
</template>

<style scoped>

.send-to-choice h2 {
  text-align: center;
}

.send-to-choice .form-group {
  display: inline-block;
  text-align: center;
  width: 50%;
  vertical-align: middle;
}

.send-to-choice .form-group label {
  margin-left: 10px;
}

</style>
